<template>
  <el-dialog
    :title="$t('calibration.edit_details_calibration')"
    v-if="this.isCreate() || this.isUpdate()"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top="2%"
    width="80%"
    :before-close="handleClose"
  >
    <card class="custom-shadow-card-header">
      <div
        v-if="
          catchDetails && catchDetails.details && catchDetails.details.length
        "
      >
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
            <label class="font-weight-bold">{{
              $t('common_words.save_date')
            }}</label>
            <br />
            {{ catchDetails.date_save }}
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
            <label class="font-weight-bold">{{
              $t('common_words.allotment')
            }}</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-lots lote-form"
              size="large"
              v-model="catchDetails.lot_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + '-' + option.id"
              ></el-option>
            </el-select>
          </div>

          <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <label class="font-weight-bold">{{
              $t('calibration.lever_gang')
            }}</label>
            <fg-input
              ref="gang"
              min="0"
              type="number"
              v-model="catchDetails.gang"
              class="text-center input-gang"
              name="calibration.lever_gang"
              :placeholder="`${$t('calibration.lever_gang')}...`"
              @input="changeGang"
            />
          </div>
        </div>

        <br />
        <div class="table-scroll-custom">
          <table class="table table-striped table-bordered">
            <thead class="cusmtom-thead-color">
              <tr>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('calibration.number_of_bunches') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('calibration.hands_type') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('common_words.age') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.ribbon') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('calibration.calibration') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(detail, index) in catchDetails.details"
                :key="detail.id"
              >
                <!-- Cluster -->
                <td class="text-center align-middle" style="min-width: 60px">
                  {{ detail.cluster }}
                </td>

                <!-- Tipo de Mano -->
                <td class="text-center align-middle" style="min-width: 200px">
                  {{ detail.calibration_type }}
                </td>

                <!-- Edad -->
                <td class="text-center" style="min-width: 100px">
                  <el-select
                    clearable
                    class="select-default shadow-sm required-second-step"
                    v-model="detail.age"
                    :placeholder="`${$t('common_words.select')}...`"
                    size="small"
                    @change="handleAgeChange(detail, index)"
                  >
                    <el-option
                      v-for="age in ages"
                      :key="age.id"
                      :value="age.id"
                      :label="age.name"
                    />
                  </el-select>
                </td>

                <!-- Cinta (color) -->
                <td class="text-center align-middle" style="min-width: 120px">
                  <span
                    class="px-2 py-1 rounded d-inline-block"
                    :style="getRibbonStyle(detail)"
                  >
                    {{ detail.ribbon_name || '-' }}
                  </span>
                </td>

                <!-- Calibración  -->
                <td class="text-center custom-td-pd" style="min-width: 100px">
                  <fg-input
                    type="number"
                    step="0.1"
                    class="m-3 text-center required-calibration"
                    v-model="detail.calibration"
                    :name="`calibration.calibration`"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <hr />

        <div class="row">
          <div class="col-12">
            <div class="has-label">
              <label>{{ $t('common_words.observation') }}</label>
              <br />
              <el-input
                maxlength="300"
                show-word-limit
                type="textarea"
                :rows="2"
                placeholder="..."
                v-model="catchDetails.observation"
                class="shadow-sm"
              ></el-input>
              <br />
              <br />
            </div>
          </div>
        </div>
        <hr />
        <div class="text-right mt-2">
          <span class="dialog-footer">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="handleClose"
            >
              {{ $t('common_words.cancel') }}</button
            >&nbsp;
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="saveChanges"
            >
              {{ $t('common_words.confirm') }}
            </button>
          </span>
        </div>
      </div>

      <div v-else class="text-center py-5">
        <p>{{ $t('common_words.no_records_found') }}</p>
      </div>
    </card>
  </el-dialog>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'CalibrationEditDetails',

  props: {
    visible: { type: Boolean, required: true },
    catchDetails: { type: Object, required: true },
  },

  data() {
    return {
      ribbonColorsByAge: [],
      lots: [],
    };
  },
  mixins: [mixinMasters, MixinPermissions],
  computed: {
    ages() {
      return [
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
        { id: 11, name: '11' },
        { id: 12, name: '12' },
        { id: 13, name: '13' },
        { id: 14, name: '14' },
        { id: 15, name: '15' },
      ];
    },
  },

  watch: {
    visible(val) {
      if (val && this.catchDetails) {
        this.loadRibbonColors();
        this.getLots(this.catchDetails.farm_id);
      }

      this.catchDetails.details.forEach((d) => {
        if (d.age === 0) {
          d.age = null;
          d.ribbon_id = null;
          d.ribbon_name = null;
          d.ribbon_color = null;
          d.ribbon_text_color = null;
        }
      });
    },
  },

  methods: {
    getLots(farmId) {
      Axios.getMasters(`lots/${farmId}`)
        .then((response) => {
          this.lots = response.data.data || [];
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    },

    loadRibbonColors() {
      if (!this.catchDetails.date_save || !this.catchDetails.farm_id) return;

      Axios.getMasters(
        `calibration/ribbons/colors/${this.catchDetails.date_save}/${this.catchDetails.farm_id}`
      )
        .then((response) => {
          this.ribbonColorsByAge = response.data.colors_by_age || [];
        })
        .catch((error) => {
          SweetAlert.warning(
            error.response.data.message ||
              'Error al cargar los colores de cinta.'
          );
        });
    },

    handleAgeChange(detail, index) {
      if (!detail.age) {
        this.clearRibbonData(detail);
        this.$set(this.catchDetails.details, index, detail);
        return;
      }

      const selectedRibbon = this.ribbonColorsByAge.find(
        (r) => r.age == detail.age
      );

      if (selectedRibbon) {
        detail.ribbon_id = selectedRibbon.ribbon_id;
        detail.ribbon_name = selectedRibbon.color_name;
        detail.ribbon_color = selectedRibbon.color_code;
        detail.ribbon_text_color = selectedRibbon.color_text;
      } else {
        this.clearRibbonData(detail);
      }

      this.$set(this.catchDetails.details, index, detail);
    },

    clearRibbonData(detail) {
      detail.ribbon_id = null;
      detail.ribbon_name = null;
      detail.ribbon_color = null;
      detail.ribbon_text_color = null;
    },

    getRibbonStyle(detail) {
      if (!detail.ribbon_color) return {};

      return {
        backgroundColor: detail.ribbon_color,
        color: detail.ribbon_text_color || '#fff',
        borderRadius: '4px',
        fontWeight: 'bold',
        padding: '2px 6px',
        minWidth: '80px',
      };
    },

    changeGang(value) {
      if (value === null || value === undefined) {
        this.catchDetails.gang = null;

        return;
      }

      let valStr = String(value);

      if (valStr.length > 4) {
        valStr = valStr.slice(0, 4);
        this.catchDetails.gang = valStr;
      }
    },

    saveChanges() {
      this.catchDetails.details.forEach((d) => {
        if (!d.age) {
          d.age = 0;
          d.ribbon_id = null;
        }
      });
      if (!this.catchDetails.lot_id) {
        SweetAlert.warning(this.$t('common_words.select_lot'));

        return;
      }
      const invalid = this.catchDetails.details.some(
        (d) => d.calibration < 28 || d.calibration > 60
      );

      if (invalid) {
        SweetAlert.warning(this.$t('calibration.edit_outside_allowed_range'));

        return;
      }

      this.$emit('save', this.catchDetails);
      this.handleClose();
    },

    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style scoped>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}

.custom-td-pd {
  padding: 0px !important;
}

.table-scroll-custom {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: auto;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
